import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { ProductoDestino } from '../_models/producto-destino';
import {ProductoSubDestinos} from '../_models/producto-subDestinos';
import {ProductosSubDestinosMontos} from '../_models/producto-subdestino-monto';

@Injectable({
  providedIn: 'root'
})
export class ProductoSubdestinoService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/productosSubDestinos';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as ProductoSubDestinos[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as ProductoSubDestinos[] ) );
  }

  listadoPorDestino( idProductoDestino: string ) {
    return this.httClient.get( this.rutServicio + '/productoDestino/' + idProductoDestino ).pipe( map( res => res as ProductoSubDestinos[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as ProductoSubDestinos ) );
  }

  crear( regCrear: ProductoSubDestinos ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as ProductoSubDestinos ) );
  }
hola
  actualizar( regActualizar: ProductoSubDestinos ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as any ) );
  }

  bulk( regActualizar: ProductoSubDestinos[] ) {
    regActualizar.map( ( s: ProductoSubDestinos ) => {
      s.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    } );
    return this.httClient.post( this.rutServicio + '/bulk', regActualizar  ).pipe( map( res => res as any ) );
  }

  listadoPorProducto( idProducto: string ) {
    return this.httClient.get( this.rutServicio + '/producto/' + idProducto ).pipe( map( res => res as ProductoSubDestinos[] ) );
  }
}
